export const environment = {
  production: true,
  name: "prod",
  apiUrl: 'https://api.harvestmate.au/v2/',
  cognito: {
    userPoolId: 'ap-southeast-2_fHzdUSSri',
    userPoolWebClientId: '3t7mptu2vrm5fa1lpscrmhb3i7',
  },
  keys: {
    currentUser: 'sra_cognito_user',
    accessKey: 'sra_user_credentials_access_key',
    secretKey: 'sra_user_credentials_secret_key',
    sessionToken: 'sra_user_credentials_session_token',
    userType: 'sra_user_type',
    accessToken: 'sra_user_credentials_access_token',
    date: 'current date',
  },
  aws: {
    region: 'ap-southeast-2',
    identityPoolId: 'fe784d12-5344-4987-ad07-fc9e92250003',
  },
};